import nl2br from 'nl2br'

export default {
  methods: {
    /**
     * Decodes HTML entities to plain text
     * 
     * @param text - The text to decode
     * @returns The decoded text
     */
    decodeHtmlEntities(text) {
      const textarea = document.createElement('textarea')
      textarea.innerHTML = text
      return textarea.value
    },
    parseToastMessage(message) {
      return nl2br(this.decodeHtmlEntities(message))
    },
    showAddedToBasketNotification (name, type = 'info') {
      if (!name) {
        name = this._('Product')
      }
      this.$toast.success(this._('%s added to basket.').replace('%s', name))
    },
    showAddedToBasketError (err) {
      console.log(err)
      this.$toast.error(this.parseToastMessage(this.getErrorMessage(err, this._('Adding the product to basket failed:') + ' ' + this._('There was an unknown error.'))))
    },
    showError (err, defaultMessage, show404 = false) {
      // When we get a 404 error, we should just close the details view and not show an error
      if (err && err.response && err.response.status === 404 && !show404) {
        if (this.close) {
          this.close()
        }
        return
      }
      this.$toast.error(this.parseToastMessage(this.getErrorMessage(err, defaultMessage)))
      if(this.$sentry && typeof err !== 'string' && this.getErrorMessage(err) === this._('There was an unknown error.')) {
        this.$sentry.captureException(err)
      }
    },
    showWarning (err, defaultMessage) {
      this.$toast.warning(this.parseToastMessage(this.getErrorMessage(err, defaultMessage)), { autoClose: 8000 })
    },
    showNotification (err, defaultMessage) {
      this.$toast(this.parseToastMessage(this.getErrorMessage(err, defaultMessage)))
    },
    showCustomNotification (text, parameters) {
      this.$toast(this.parseToastMessage(text), parameters)
    },
    getErrorMessage (err, defaultMessage) {
      if (err && err.response && err.response.data && err.response.data.errorMessage) {
        return err.response.data.errorMessage
      }
      if (err && err.response && err.response.data && err.response.data.message) {
        return err.response.data.message
      }
      if (err && err.errorMessage) {
        return err.errorMessage
      }
      if (err && err.message) {
        return err.message
      }
      if (defaultMessage) {
        return defaultMessage
      }
      if (typeof err === 'string') {
        return err
      }
      return this._('There was an unknown error.')
    }
  }
}